import page from "page";
import React from "react";
import { render } from "react-dom";
import regeneratorRuntime from "regenerator-runtime";
import PlayVideo from "../helpers/PlayVideo";
import log from "../helpers/log";
import objectsResize from "../helpers/gamescreen/objectsResize";
import lazyAdsense from "../helpers/lazyAdsense";
import rePreroll from "../helpers/gamescreen/rePreroll";
import GameContainer from "../components/gamescreen/gameContainer.jsx";
import AnunciosPreJuego from "../components/gamescreen/AnunciosPreJuego.jsx";

export default async () => {
	// Fix Go Back Section
	function goBack(ctx, next) {
		window.location.href = ctx.path;
	}
	if (document.referrer != "") {
		if (document.referer != window.location.href) {
			const slug = document.referrer.split("/")[3];
			if (window.location.href.split("/").length >= 4) {
				if (slug != window.location.href.split("/")[3]) {
					page(`/${slug}/:second/:page`, goBack);
					page(`/${slug}/:second`, goBack);

					page();
					$("html,body").animate(
						{
							scrollTop: $(".Main").offset().top,
						},
						1000
					);
				}
			}
		}
	}

	// HANDLE EMBED REDIRECTS
	if (window.location.hash === "#embed") {
		$("body").append(
			`<a href="/embed/${gameSettings.gameInfo.embed_url} " rel="noreferrer" id="redirect-url">Link</a>`
		);
		document.getElementById("redirect-url").click();
	}
	objectsResize();
	window.played_count = 0;

	const GamesPlayed = JSON.parse(localStorage.getItem("games_played"));
	if (GamesPlayed !== null) {
		window.played_count = GamesPlayed.length;
	}

	tryAds();

	function runGame() {
		console.log("Running Game");
		render(
			<GameContainer
				{...gameSettings}
				cdn={window.cdns[0]}
				translate={translate}
			/>,
			document.getElementById("gameContainer")
		);
	}
	function tryAds() {
		console.log("Running Ads Intent");
		if (typeof google === "undefined") {
			runGame();
		} else if (gameSettings.preroll && rePreroll.showPrerol()) {
			render(
				<AnunciosPreJuego
					{...gameSettings}
					translate={translate}
					onFinish={runGame}
				/>,
				document.getElementById("gameContainer")
			);
		} else {
			runGame();
		}
	}

	lazyAdsense("#BannerCentral2", 150, "play_center_2");
	$("#anuncioBajoJuego").html(gameSettings.ads.play_center_1);
	new PlayVideo();
};
